export default __webpack_public_path__ + "img/a52014f4a17b240073e513e99f0ed08b.png";